/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface SearchAccounts200ResponseResultsInner
 */
export interface SearchAccounts200ResponseResultsInner {
    /**
     * 
     * @type {Account}
     * @memberof SearchAccounts200ResponseResultsInner
     */
    entity?: Account;
    /**
     * Relevance score (0-1)
     * @type {number}
     * @memberof SearchAccounts200ResponseResultsInner
     */
    score?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchAccounts200ResponseResultsInner
     */
    matchedFields?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof SearchAccounts200ResponseResultsInner
     */
    highlights?: object;
}

/**
 * Check if a given object implements the SearchAccounts200ResponseResultsInner interface.
 */
export function instanceOfSearchAccounts200ResponseResultsInner(value: object): value is SearchAccounts200ResponseResultsInner {
    return true;
}

export function SearchAccounts200ResponseResultsInnerFromJSON(json: any): SearchAccounts200ResponseResultsInner {
    return SearchAccounts200ResponseResultsInnerFromJSONTyped(json, false);
}

export function SearchAccounts200ResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAccounts200ResponseResultsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'entity': json['entity'] == null ? undefined : AccountFromJSON(json['entity']),
        'score': json['score'] == null ? undefined : json['score'],
        'matchedFields': json['matchedFields'] == null ? undefined : json['matchedFields'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
    };
}

  export function SearchAccounts200ResponseResultsInnerToJSON(json: any): SearchAccounts200ResponseResultsInner {
      return SearchAccounts200ResponseResultsInnerToJSONTyped(json, false);
  }

  export function SearchAccounts200ResponseResultsInnerToJSONTyped(value?: SearchAccounts200ResponseResultsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entity': AccountToJSON(value['entity']),
        'score': value['score'],
        'matchedFields': value['matchedFields'],
        'highlights': value['highlights'],
    };
}

